import { IAccordionItemProps } from '@cian/ui-kit';

export const FAQ: IAccordionItemProps[] = [
  {
    title: 'Сколько стоят ваши услуги?',
    content:
      'Поиск надежного риелтора, подключение максимального продвижения и поддержка команды — бесплатно. Оплатить нужно только услуги риелтора и только после успешного завершения сделки. Размер комиссии зависит от особенностей объекта и специфики сделки, но можно ориентироваться на среднее значение по рынку – 2,5-3%',
  },
  {
    title: 'Как быстро я продам квартиру?',
    content:
      'На скорость продажи влияет много факторов, но по нашей статистике, вместе со Сделкой объекты продаются на 4–5 недель быстрее, чем самостоятельно',
  },
  {
    title: 'Как мне быть уверенным в профессионализме риелтора?',
    content:
      'В Сделке работают только партнёрские агентства, за которые мы ручаемся: проверили лично, подобрали по рейтингу и отзывам, оценили опыт решения сложных кейсов',
  },
  {
    title: 'Что делать, если мне не понравится риелтор?',
    content:
      'По любым вопросам вы сможете обратиться к нам, и мы подключимся, чтобы помочь и подобрать другого специалиста',
  },
  {
    title: 'Риелтор поможет с документами и проверкой покупателя?',
    content:
      'Риелтор поможет на каждом этапе, в том числе с оформлением и проверкой документов и покупателей, а также сопроводит вас на самой сделке и убедится в безопасности расчётов',
  },
];
